import {ErrorHandler, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {AppCommonModule} from './app-common/app-common.module';
import {AuthModule} from './auth/auth.module';
import {AppRoutingModule} from './routing/app-routing.module';
import {ToastModule} from 'primeng/toast';
import {ConfirmationService, MessageService} from 'primeng/api';
import {PermissionModule} from './permission/permission.module';
import {CustomTooltipModule} from './tooltip/custom-tooltip.module';
import {VirtualScrollModule} from './virtual-scroll/virtual-scroll.module';
import {QueryModule} from './query/query.module';
import {NgxElectronModule} from 'ngx-electron';
import {AppTabComponent} from './tabbing/components/app-tab/app-tab.component';
import {NgxFsModule} from 'ngx-fs';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CacheInterceptor} from './app-common/services/server/cache.interceptor';
import {HttpErrorInterceptor} from './app-common/services/server/http-error.interceptor';
import {JWTInterceptor} from './app-common/services/server/jwt.interceptor';
import {HARInterceptor} from './app-common/services/server/har.interceptor';
import {AccordionModule} from 'primeng/accordion';
import {SelectButtonModule} from 'primeng/selectbutton';
import {SettingsPageComponent} from './settings/pages/settings-page/settings-page.component';
import {GeneralTabComponent} from './settings/section-tabs/general-tab/general-tab.component';
import {EmailingTabComponent} from './settings/section-tabs/emailing-tab/emailing-tab.component';
import {TestingGroundModule} from './_testing-ground/testing-ground.module';
import {JsonDateInterceptor} from './app-common/services/server/json-date.interceptor';
import {CommunicationCommonModule} from './communication-common/communication-common.module';
import {ResourcesModule} from './video/resources.module';
import {WidgetLibraryModule} from './_widget-library/widget-library.module';
import {HeadlessModule} from './headless/headless.module';
import {CustomErrorHandler} from './logging/services/custom-error-handler';
import {EmailSettingsComponent} from './emailing/components/email-settings/email-settings.component';
import {SkeletonModule} from 'primeng/skeleton';
import {MainWindowComponent} from './app-common/windows/main-window/main-window.component';
import {HeadlessWindowComponent} from './app-common/windows/headless-window/headless-window.component';
import {AiAssistantModule} from './ai-assistant/ai-assistant.module';
import {ConfirmDialogModule} from 'primeng/confirmdialog';

@NgModule({
  declarations: [
    AppComponent,
    AppTabComponent,
    SettingsPageComponent,
    GeneralTabComponent,
    EmailingTabComponent,
    EmailSettingsComponent,
    MainWindowComponent,
    HeadlessWindowComponent,
  ],
    imports: [
        NgxElectronModule,
        FormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AccordionModule,
        AppCommonModule,
        AuthModule,
        PermissionModule,
        AppRoutingModule,
        ToastModule,
        CustomTooltipModule,
        VirtualScrollModule,
        QueryModule,
        NgxFsModule,
        SelectButtonModule,
        TestingGroundModule,
        CommunicationCommonModule,
        ResourcesModule,
        WidgetLibraryModule,
        HeadlessModule,
        SkeletonModule,
        AiAssistantModule,
        ConfirmDialogModule,
    ],
  providers: [MessageService,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HARInterceptor, multi: true },
    ConfirmationService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
